export const API_URL = process.env.REACT_APP_API_URL;

export const DEVICE_TYPE_MAP = {
    Aksioma01: 'Аксиома-01',
    Aksioma03: 'Аксиома-03',
    Karat307: 'Карат-307'
};

export const HC_MIT_NUMBERS = {
    Aksioma01: '53677-13',
    Aksioma03: '53677-13',
    Karat307: '61255-15'
};

export const DEVICE_TYPE_NAMES = {
    'heat-computer': 'Тепловычислитель',
    'temp-sensor': 'Датчик температуры',
    'pressure-sensor': 'Датчик давления',
    'flow-meter': 'Расходомер'
};

export const POSITION_OPTIONS = {
    'temp-sensor': ['t1', 't2', 't3', 't4', 'tx', 'tok'],
    'pressure-sensor': ['P1', 'P2', 'P3', 'P4', 'Px'],
    'flow-meter': ['V1', 'V2', 'V3', 'V4', 'Vx']
};

export const SECTION_NAMES = {
    'heat-computer': 'Тепловычислитель',
    'temp-sensor': 'Датчик температуры',
    'pressure-sensor': 'Датчик давления',
    'flow-meter': 'Расходомер'
};

export const DEVICE_MODELS = {
    Aksioma01: 'Аксиома-01',
    Aksioma03: 'Аксиома-03',
    Karat307: 'Карат-307'
};

export const DEVICE_PLACEHOLDERS = {
    'flow-meter': {
        type: 'Расходомер-счетчик электромагнитный',
        model: 'КАРАТ-551-40',
        specs:
            'Вес импульса 1 л/импульс;\nQmin (Vmin) 0,18 м³/ч;\nQt1 (Vper) 0,45 м³/ч;\nQmax (Vmax) 45 м³/ч.'
    },
    'temp-sensor': {
        type: 'Комплект термометров сопротивления',
        model: 'КТПТР-06',
        specs:
            'Температурный коэффициент 000391°С-1;\nНоминальное сопротивление 100 Ом;\ntmin 10°C; tmax 95°C.'
    },
    'pressure-sensor': {
        type: 'Преобразователь давления измерительный КАРАТ',
        model: 'СДВ-И-2,5-1,6-1,0-М-4-20 мА-DA422-0605-3',
        specs: 'Верхний предел измерения 1,6 МПа;\nВыходной сигнал 4-20 мА.'
    }
};

export const NODE_STATUS_META = {
    1: {
        label: 'Введен в эксплуатацию',
        badge: 'bg-green-500/15 border-green-500/40 text-green-400',
        icon: 'CheckCircle'
    },
    2: {
        label: 'Ожидание оплаты',
        badge: 'bg-amber-500/15 border-amber-500/40 text-amber-400',
        icon: 'Clock'
    },
    3: {
        label: 'На поверке',
        badge: 'bg-blue-500/15 border-blue-500/40 text-blue-400',
        icon: 'Wrench'
    },
    4: {
        label: 'Выведен из эксплуатации',
        badge: 'bg-slate-600/20 border-slate-600/50 text-slate-400',
        icon: 'XCircle'
    }
};

export const plural = (n, one, few, many) => {
    const abs = Math.abs(n) % 100;
    const d = abs % 10;

    if (abs > 10 && abs < 20) return many;
    if (d === 1) return one;
    if (d >= 2 && d <= 4) return few;

    return many;
};

export const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
};

export const formatHex = (value, padding = 4) => {
    if (value === null || value === undefined) return '';

    return `0x${Number(value).toString(16).toUpperCase().padStart(padding, '0')}`;
};

export const formatDateForInput = (dateStr) => {
    if (!dateStr) return '';

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
    }

    if (/^\d{2}\.\d{2}\.\d{4}$/.test(dateStr)) {
        const [day, month, year] = dateStr.split('.');

        return `${year}-${month}-${day}`;
    }

    const d = new Date(dateStr);

    if (!Number.isNaN(d)) {
        return d.toISOString().split('T')[0];
    }

    return '';
};

export const getCommissioningState = (node) => {
    if (node.status !== 1 || !node.oplombirovanValidUntil) {
        return null;
    }

    const parts = node.oplombirovanValidUntil.split('.');

    if (parts.length !== 3) {
        return null;
    }

    const [day, month, year] = parts;

    const validUntil = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    validUntil.setHours(0, 0, 0, 0);

    const diffDays = Math.ceil((validUntil - today) / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
        return {
            text: `истёк ${node.oplombirovanValidUntil}`,
            colorClass: 'bg-red-500/15 border-red-500/40 text-red-400'
        };
    }

    if (diffDays <= 10) {
        return {
            text: `до ${node.oplombirovanValidUntil} (осталось ${diffDays} ${plural(diffDays, 'день', 'дня', 'дней')})`,
            colorClass: 'bg-yellow-500/15 border-yellow-500/40 text-yellow-400'
        };
    }

    return {
        text: `до ${node.oplombirovanValidUntil}`,
        colorClass: 'bg-green-500/15 border-green-500/40 text-green-400'
    };
};